import { type ICombinedState } from '../reducers';

export const currentUserSelector = (state: ICombinedState) => state.auth.user;
